import { createRouter, createWebHashHistory } from "vue-router";
import { getTokenAUTH } from "@/utils/auth";
import { ElNotification } from "element-plus";

import home from "../views/home.vue";
import login from "../views/auth/login.vue";
// 用户管理
import userList from "../views/userManage/userList.vue";
import memberUpgrade from "../views/userManage/memberUpgrade.vue";
import userAddress from "../views/userManage/userAddress.vue";
import userTransfer from "../views/userManage/userTransfer.vue";
import userWallet from "../views/userManage/userWallet.vue";
import levelLogLists from "../views/userManage/levelLogLists.vue";
import moneyChangeList from "../views/userManage/moneyChangeList.vue";

// 运营管理

import bannerList from "../views/operationManage/bannerList.vue";

import newsTypeList from "../views/operationManage/newsTypeList.vue";

import newsList from "../views/operationManage/newsList.vue";

import lottory from "../views/operationManage/lottory.vue";

import lottoryDetails from "../views/operationManage/lottoryDetails.vue";

import lotteryTimeSettings from "../views/operationManage/lotteryTimeSettings.vue";

import letters from "../views/operationManage/letters.vue";

import userFeedback from "../views/operationManage/userFeedback.vue";

// 系统设置
import googleKeys from "../views/sysSetting/googleKeys.vue";

// 视频管理
import videoType from "../views/videoManage/videoType.vue";
import videoList from "../views/videoManage/videoList.vue";
import xuanchuanVideo from "../views/videoManage/xuanchuanVideo.vue";

// 后台管理
import backendUser from "../views/backendManage/backendUser.vue";
import loginLog from "../views/backendManage/loginLog.vue";

const routes = [
  {
    path: "/",
    redirect: "home",
  },
  {
    path: "/login",
    name: "login",
    component: login,
  },
  {
    path: "/home",
    name: "home",
    component: home,
  },
  {
    path: "/userList",
    name: "userList",
    component: userList,
  },

  // {
  //   path: "/memberLevel",
  //   name: "memberLevel",
  //   component: memberLevel,
  // },
  {
    path: "/memberUpgrade",
    name: "memberUpgrade",
    component: memberUpgrade,
  },
  {
    path: "/moneyChangeList",
    name: "moneyChangeList",
    component: moneyChangeList,
  },
  // {
  //   path: "/userLoginLog",
  //   name: "userLoginLog",
  //   component: userLoginLog,
  // },
  {
    path: "/userAddress",
    name: "userAddress",
    component: userAddress,
  },
  {
    path: "/userTransfer",
    name: "userTransfer",
    component: userTransfer,
  },
  {
    path: "/userWallet",
    name: "userWallet",
    component: userWallet,
  },
  {
    path: "/levelLogLists",
    name: "levelLogLists",
    component: levelLogLists,
  },

  {
    path: "/bannerList",
    name: "bannerList",
    component: bannerList,
  },

  {
    path: "/newsTypeList",
    name: "newsTypeList",
    component: newsTypeList,
  },

  {
    path: "/newsList",

    name: "newsList",

    component: newsList,
  },

  {
    path: "/lottory",
    name: "lottory",
    component: lottory,
  },
  {
    path: "/lottoryDetails",
    name: "lottoryDetails",
    component: lottoryDetails,
  },
  {
    path: "/lotteryTimeSettings",
    name: "lotteryTimeSettings",
    component: lotteryTimeSettings,
  },
  {
    path: "/letters",
    name: "letters",
    component: letters,
  },

  {
    path: "/userFeedback",

    name: "userFeedback",

    component: userFeedback,
  },

  {
    path: "/googleKeys",
    name: "googleKeys",
    component: googleKeys,
  },
  {
    path: "/videoType",
    name: "videoType",
    component: videoType,
  },
  {
    path: "/videoList",
    name: "videoList",
    component: videoList,
  },
  {
    path: "/xuanchuanVideo",
    name: "xuanchuanVideo",
    component: xuanchuanVideo,
  },
  {
    path: "/backendUser",
    name: "backendUser",
    component: backendUser,
  },
  {
    path: "/loginLog",
    name: "loginLog",
    component: loginLog,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path == "/login") {
    next();
  } else {
    if (!getTokenAUTH()) {
      ElNotification({
        title: "Error",
        message: "您还没有登录，请先登录",
        type: "error",
      });
      next("/login");
    } else {
      next();
    }
  }
});

export default router;
